import Image from "next/legacy/image";
import Link from "next/link";
import format from "date-fns/format";
import useWindowSize from "../../lib/hooks/useWindowSize";

import { nextGenImageFormat } from "utils/image";

import styles from "./FeaturedBlog.module.scss";

const FeaturedBlog = ({
  title,
  description,
  date,
  author,
  imageLarge,
  imageSmall,
  slug,
}) => {
  const { width } = useWindowSize();

  return (
    <Link href={`stories/${slug}`} passHref aria-label="blog-detail">
      <div className={`${styles.wrapper}`}>
        <div className="variable-container">
          <div className={`${styles.imageWrapper}`}>
            <Image
              className={`${styles.image}`}
              src={nextGenImageFormat(imageLarge)}
              layout="fill"
              alt="blog-image"
              loading="lazy"
              style={{
                position: "relative",
              }}
            />
            <div className={`${styles.content}`}>
              <h2 className={`${styles.featuredTitle}`}>{title}</h2>
              <div className={`${styles.date}`}>
                {format(new Date(date), "dd MMM yyyy")} | {author || "unKnown"}
                {width > 767 ? (
                  <Image
                    src="/assets/img/icons/arrow-right-feat.svg"
                    alt="Arrow right icon"
                    width="36"
                    height="29"
                    layout="fixed"
                  />
                ) : (
                  <Image
                    src="/assets/img/icons/long-arr.svg"
                    alt="Long arrow image"
                    width="45"
                    height="10"
                    layout="fixed"
                  />
                )}
              </div>
            </div>
            <div className={`${styles.quote}`}>
              <p className={`${styles.description}`}>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedBlog;
